import classNames from 'classnames';
import React from 'react';
import 'presentation/components/styles/FloatingLabel.css';

// This is not our component, it is from https://www.npmjs.com/package/react-floating-label-input
// We had to add !important to each inline css because we need to make sure our widget css is not
// overriden by the hosting page
// Since React does not support !important inline styles, we need to use a ref function

type Props = {
  className?: string,
  fontSize?: string,
  id: string,
  label: string,
  onBlur?: Event => void,
  onChange: Event => void,
  onKeyPress: Event => void,
  onFocus?: Event => void,
  placehold?: string,
  shrink?: number,
  type?: string,
};

export default class FloatingLabelInput extends React.Component {
  constructor(props) {
    super(props);

    if (!props.id) {
      throw new Error('expectd id but none present');
    }

    if (props.shrink && (props.shrink < 1 || props.shrink > 99)) {
      throw new Error('shrink prop must be between 1 and 99');
    }

    this.state = {
      active: props.value && props.value.length > 0,
    };
  }

  render() {
    const {
      className,
      fontSize,
      id,
      label,
      onBlur,
      onChange,
      onKeyPress,
      onFocus,
      shrink,
      placeholder,
      type,
      value,
    } = this.props;
    const { active } = this.state;

    return (
      <div
        className={classNames('react-floating-label-input', {
          active,
          [className]: !!className,
        })}
      >
        <div
          className="container"
          style={{
            fontSize: fontSize ? fontSize : 'inherit',
            height: shrink ? `${1.2 + shrink / 100}em` : `2em`,
          }}
        >
          <label
            htmlFor={id}
            ref={node => {
              if (node) {
                if (active) {
                  node.style.setProperty(
                    'transform',
                    `translate3d(0, -${shrink || '70'}%, 0) scale(0.${shrink || '70'})`,
                    'important'
                  );
                } else {
                  node.style.setProperty('transform', 'none', 'important');
                }
              }
            }}
          >
            {label}
          </label>
          <input
            id={id}
            onBlur={event => {
              this.setState({ active: event.target.value.length !== 0 });
              if (onBlur) {
                onBlur(event);
              }
            }}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onFocus={event => {
              this.setState({ active: true });
              if (onFocus) {
                onFocus(event);
              }
            }}
            placeholder={placeholder}
            type={type || 'text'}
            value={value || ''}
          />
        </div>
      </div>
    );
  }
}
